import Plugin from 'src/plugin-system/plugin.class';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default class HomepageLKWPlugin extends Plugin {

    init() {
        gsap.registerPlugin(ScrollTrigger);

        let tl = gsap.timeline({
            scrollTrigger: {
              trigger: '.homepage-lkw-widget__lkw-image-wrapper',
              start: "top 70%",
              end: "bottom 40%",
              scrub: 1,
              //markers: true
            }
        });
        
        tl.to('.homepage-lkw-widget__lkw-image-wrapper img[data-step="1"]', { opacity: 1 });
        tl.to('.homepage-lkw-widget__lkw-image-wrapper img[data-step="2"]', { opacity: 1 });
        tl.to('.homepage-lkw-widget__lkw-image-wrapper img[data-step="3"]', { opacity: 1 });
    }

}